(() => {
  'use strict';
  if (document.documentElement.dataset.gosEnabled !== 'true') return;
  const openers = new WeakMap();
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-gos-open]');
    if (opener) {
      const dialog = opener.closest('[data-gos-sweepstakes]')?.querySelector('dialog');
      if (!dialog || dialog.open) return;
      openers.set(dialog, opener);
      dialog.addEventListener('close', () => openers.get(dialog)?.focus(), { once: true });
      dialog.showModal();
      dialog.querySelector('[data-gos-close]')?.focus();
      return;
    }
    const closer = event.target.closest('[data-gos-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    if (event.target.matches('dialog.gos-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
})();
